import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import currencyActions from '../actions/currency';
import {isPPM, isSWSwitchIPM, isUsSite} from '../utils/validate';
import {DEEP_LINK_PARAM_TYPE, removeDeepLinkParams} from '../utils/localStorageDataHandler';
import {isEmpty} from 'lodash';

const isCommercialFlowEnabled = (userInfo, siteName) => {
    const {propertyCount, companyCountryCode} = userInfo;

    // For Software Switch IPMs those who are midway before offer 2 release
    return !isUsSite(siteName) && !isEmpty(companyCountryCode) && !isEmpty(propertyCount);
};

function updateCurrency(store, action) {
    const {currency, userInfo} = action.payload;
    const state = store.getState();
    const siteName = state.system.siteName;
    const userType = state.app.userType;

    request.post(`/${config.url_prefix}/api/updateCurrency`)
        .send({
            data: currency
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(currencyActions.currencyServiceError('internal.server.error'));
            } else if (!response || response.code > 400 || response.statusCode > 400) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(currencyActions.currencyServiceError('ipmob.error.process.request'));
            } else {
                store.dispatch(currencyActions.currencyServiceError(false));
                removeDeepLinkParams(DEEP_LINK_PARAM_TYPE.pmscParams); // remove PMSC params from local storage
                if (isPPM(userType)) {
                    store.dispatch(actions.changeAppState('LISTING_MODEL'));
                } else if (isCommercialFlowEnabled(userInfo, siteName) && isSWSwitchIPM(userType)) {
                    store.dispatch(actions.changeAppState('LISTING_MODEL'));
                } else if (isSWSwitchIPM(userType)) {
                    store.dispatch(actions.changeAppState('BILLING_INFORMATION'));
                } else {
                    const companyRegistration = state.userInfoDetails.userInfoMetadata.ipm.companyRegistration;
                    if ((siteName === 'homeaway_us') || (siteName === 'vrbo') || (siteName === 'vr') || companyRegistration) {
                        store.dispatch(actions.changeAppState('LISTING_MODEL'));
                    } else {
                        store.dispatch(actions.changeAppState('VAT_INFORMATION'));
                    }
                }
            }
        });
}

export default updateCurrency;
